export class PreBillingBook {

  preBillingArticles: PreBillingArticle[]
  incompleteBillingDatas: incompleteBillingData[]
  totalPrice: number;

  static fromObject(object: any): PreBillingBook {
    return Object.assign(new PreBillingBook(), {
      preBillingArticles: object.articles.map(item => PreBillingArticle.fromObject(item)),
      incompleteBillingDatas: object.incompleteBillingData.map(item => incompleteBillingData.fromObject(item)),
      totalPrice: object.totalPrice,
    });
  }
}

export class PreBillingArticle {
  id: string;
  code: string;
  quantity: number;
  sender: string;
  steps: string[];
  urgency: string;
  lot: string;
  unitPrice: number;
  unitWaitingPrice: number;
  totalWaitingPrice: number;
  priceType: string;
  totalPrice: number;

  public concatSteps() {
    return this.steps.join(", ");
  }
  static fromObject(object: any): PreBillingArticle {
    return Object.assign(new PreBillingArticle(), {
      ...object,
    });
  }
}

export class incompleteBillingData {
  identifier: string;
  hasArticle: boolean;
  hasSchedule: boolean;
  hasWaitingTime: boolean;

  static fromObject(object: any): incompleteBillingData {
    return Object.assign(new incompleteBillingData(), {
      ...object,
    });
  }
}
